import type { FC } from 'react'

import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'

const Identification: FC<{ isEditable: boolean }> = ({ isEditable }) => (
  <Field name="birthDateOrgNo">
    {({ field, meta, form }: FieldProps) => {
      if (form.values.terminationType !== 'TRANSFER') return null

      return (
        <section>
          <h3>
            <Text id="Identifikasjon" />
          </h3>

          <Input
            id="birthDateOrgNo"
            label={<Text id="Hva er ditt personnummer (11 siffer)?" />}
            error={meta.error}
            touched={meta.touched}
            isDisabled={!isEditable}
            {...field}
          />
        </section>
      )
    }}
  </Field>
)

export default Identification
